












































import BaseButton from '@/jbi-shared/vue-components/BaseButton.vue';
import { Vue, Component, Emit, Prop } from 'vue-property-decorator';

@Component({
  components: {
    BaseButton
  }
})
export default class UnpublishCourseModal extends Vue {
  @Prop({ default: true }) isUnpublish!: boolean;

  @Emit('close')
  closeModal() {
    return;
  }

  handleUpdateCourseStatus() {
    if (this.isUnpublish) {
      this.triggerUnpublishCourse();
    } else {
      this.triggerRepublishCourse();
    }
  }

  @Emit('unpublishCourse')
  triggerUnpublishCourse() {
    this.closeModal();
    return;
  }

  @Emit('republishCourse')
  triggerRepublishCourse() {
    this.closeModal();
    return;
  }
}
